import { render, staticRenderFns } from "./MobileStatistics.vue?vue&type=template&id=04429af2&"
import script from "./MobileStatistics.vue?vue&type=script&lang=js&"
export * from "./MobileStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MobileStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports